"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var isString_1 = __importDefault(require("lodash/isString"));
var index_1 = require("./icons/index");
var OracleIconButton = function (_a) {
    var icon = _a.icon, _b = _a.invert, invert = _b === void 0 ? false : _b, _c = _a.border, border = _c === void 0 ? 'none' : _c, _d = _a.shape, shape = _d === void 0 ? 'circle' : _d, ariaLabel = _a["aria-label"], onClick = _a.onClick, _e = _a.type, type = _e === void 0 ? 'button' : _e, _f = _a.className, className = _f === void 0 ? '' : _f, size = _a.size, _g = _a.disabled, disabled = _g === void 0 ? false : _g;
    var baseClass = 'oracle-icon-button';
    var safeClassName = (0, isString_1.default)(className) ? className : '';
    var invertClass = invert ? "".concat(baseClass, "--inverted") : '';
    var borderClass = border !== 'none' ? "".concat(baseClass, "--border-").concat(border) : '';
    var shapeClass = shape === 'square' ? "".concat(baseClass, "--square") : '';
    var combinedClassName = "".concat(baseClass, " ").concat(invertClass, " ").concat(borderClass, " ").concat(shapeClass, " ").concat(safeClassName).trim();
    return (react_1.default.createElement("button", { type: type, className: combinedClassName, "aria-label": ariaLabel, onClick: onClick, disabled: disabled }, (0, index_1.makeIcon)(icon, size)));
};
exports.default = OracleIconButton;
